/* The client card's „Ustawienia rozliczeń" dialog. Its frame, legend, note and acts are
 * `shared/ui/formDialog`'s and its rows `shared/ui/choiceRow`'s; what stands here is the reserve
 * that keeps the answer from moving anything: three rows' room in every state, and two lines for
 * the note under them. */

.set {
  margin: var(--space-0);
  padding: var(--space-0);
  border: 0;
}

/* The failed read stands in the room the three rows take. */
.failed {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
  justify-content: center;
  min-height: calc(3 * var(--h-assign-row));
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.notes {
  display: grid;
  gap: var(--space-1);
}

.note {
  min-height: calc(2em * var(--lh-note));
  margin: var(--space-0);
}

.everyone {
  margin: var(--space-0);
}

.barMark {
  width: var(--space-14px);
  height: var(--space-14px);
  border-radius: var(--r-pill);
}

.barText {
  width: 60%;
  height: var(--space-3);
}
